
var baseApp = angular.module('base', ['ui.router']);

var adminApp = angular.module('adminApp', ['base','treeControl','daterangepicker','ngFileUpload', 'angularMoment', 'ngNotify', 'jsonFormatter']);

adminApp.constant('angularMomentConfig', {
    timezone: 'UTC'
});


var mainApp = angular.module('main', ['base','ngFileUpload', 'angularMoment', 'daterangepicker', 'ngNotify', 'color.picker']);

mainApp.constant('angularMomentConfig', {
    timezone: 'UTC'
});

baseApp.run(initConfiguration);


function initConfiguration(TimeZoneService) {
    amChartConfiguration(TimeZoneService);
}

/*
    Adding timezone handling to serial amCharts.
    Implemented by adding initHandler to every serial chart.

    This handler adds categoryFunction that is responsible for translating times to current timezone for representation.
    Handler also responsible for wrapping 'selected' handler function to convert times back to local on selection(zoom).
    This is needed because AmChart works with js Date object that uses local machines time zone.

*/
function amChartConfiguration(TimeZoneService) {

    if(AmCharts) {
        AmCharts.addInitHandler(initSerial, ['serial']);
    }

    function initSerial(chart){
        addCategoryFunction(chart);
        chart.addListener('init', chartInitHandler);
    }

    function addCategoryFunction(chart) {
        if(chart.categoryAxis) {
            chart.categoryAxis.categoryFunction = TimeZoneService.chartCategoryFunction ;
        }
    }

    function chartInitHandler(event) {
        var chart = event.chart;
        if(chart.chartCursor) {
            var cursor = chart.chartCursor;

            cursor.events.selected.forEach(event => {
                event.handler = timeZoneAwareHandler(event.handler);
            });

            var addListenerDelegate = cursor.addListener;

            cursor.addListener = addListenerWrapper;

            function addListenerWrapper(type, handler, scope) {
                if(type == 'selected') {
                    return addListenerDelegate.apply(chart, [type, timeZoneAwareHandler(handler), scope]);
                } else {
                    return addListenerDelegate.apply(chart, [type, handler, scope]);
                }
            }
        }

        function timeZoneAwareHandler(handler) {
            return function(event) {
               event.start = TimeZoneService.convertToCurrent(event.start);
               event.end = TimeZoneService.convertToCurrent(event.end);
               return handler(event);
           };
        }

    }

}
